// import React from 'react'
// import { GiElectricalSocket } from "react-icons/gi";

// const FilterProduct = ({category, onClick, isActive}) => {
//   return (
//     <div onClick={onClick}>
//         <div className={`text-3xl p-5  rounded-full cursor-pointer ${isActive?"bg-red-600 text-white": "bg-yellow-500"}`}>
//         <GiElectricalSocket />
//         </div>

//         <p className='text-center font-medium my-1 capitalize'>{category}</p>
//     </div>
//   )
// }

// export default FilterProduct


import React from 'react';

export default function FilterProduct({ category, onClick, isActive }) {
  return (
    <button
      className={`filter-pill ${isActive ? 'active' : ''}`}
      onClick={onClick}
    >
      {category}
    </button>
  );
}